/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return ResourceInventoryFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryFeatureFlagsWithDefaults>): ResourceInventoryFeatureFlagsWithDefaults {
        let obj = Object.assign(new ResourceInventoryFeatureFlagsWithDefaults(), model);
        ResourceInventoryFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryFeatureFlagsWithDefaults>): ResourceInventoryFeatureFlagsWithDefaults {
        if (!model) return null;
        return ResourceInventoryFeatureFlagsWithDefaults.newInstance(<ResourceInventoryFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.ResourceInventoryFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    rein_2504_a_test_flag: boolean = false;

}
